document.addEventListener('DOMContentLoaded', () => {

  //
  //  Example 1, Fade In Once: <div class="opacity-0 transition-opacity duration-700" data-enter-viewport="opacity-100" data-enter-once"></div>
  //  Example 2, Animate In Always: <div class="translate-y-[50px] transition-all duration-700" data-enter-viewport="opacity-100 translate-y-0" data-exit-reset><div>
  //

  // Get the utility "family" prefix (e.g. "translate-x-", "translate-y-", "opacity-")
  const getClassPrefix = (className) => {
    const normalized = className.startsWith('-') ? className.slice(1) : className;
    const parts = normalized.split('-');
    if (parts.length >= 2) {
      return parts.slice(0, -1).join('-') + '-';
    }
    return null;
  };

  // Replace classes with same family, supporting negative utilities too
  const replaceClassesWithPrefix = (element, newClasses) => {
    const appliedClasses = [];
    const current = Array.from(element.classList);

    newClasses.forEach(newClass => {
      const prefix = getClassPrefix(newClass);
      if (prefix) {
        current.forEach(existingClass => {
          if (
            existingClass.startsWith(prefix) ||       // e.g. "translate-x-"
            existingClass.startsWith('-' + prefix)    // e.g. "-translate-x-"
          ) {
            element.classList.remove(existingClass);
          }
        });
      }
      element.classList.add(newClass);
      appliedClasses.push(newClass);
    });

    return appliedClasses;
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const el = entry.target;
      const enterClasses = el.getAttribute('data-enter-viewport')?.split(' ') || [];
      const hasEnterOnce = el.hasAttribute('data-enter-once');
      const hasExitReset = el.hasAttribute('data-exit-reset');

      // Gebruik dataset-flag om te markeren dat het al is uitgevoerd
      const alreadyEntered = el.dataset.entered === 'true';

      if (entry.isIntersecting) {
        if (!alreadyEntered || !hasEnterOnce) {
          // Store original classes before modifying (only on first enter)
          if (!alreadyEntered && hasExitReset) {
            el.dataset.originalClasses = JSON.stringify(Array.from(el.classList));
          }

          // Replace classes with same prefix instead of just adding
          const appliedClasses = replaceClassesWithPrefix(el, enterClasses);
          // Store the actually applied classes for proper removal on exit
          el.dataset.appliedClasses = JSON.stringify(appliedClasses);
          el.dataset.entered = 'true';
        }
      } else {
        if (hasExitReset) {
          // Remove the classes that were actually applied
          const appliedClasses = JSON.parse(el.dataset.appliedClasses || '[]');
          el.classList.remove(...appliedClasses);

          // Restore original classes
          const originalClasses = JSON.parse(el.dataset.originalClasses || '[]');
          originalClasses.forEach(originalClass => {
            if (!el.classList.contains(originalClass)) {
              el.classList.add(originalClass);
            }
          });

          el.dataset.entered = 'false';
          el.dataset.appliedClasses = '';
          el.dataset.originalClasses = '';
        }
      }
    });
  }, {
    threshold: 0.1,
    rootMargin: '0px 0px -15px 0px',
  });

  document.querySelectorAll('[data-enter-viewport]').forEach(el => {
    observer.observe(el);
  });
});